module.exports = __webpack_public_path__ + "img/case_icon3.ab005e34.png";